<template>
    <img v-if="images.length == 1" :src="images[0]" alt="image" class="partial-image" />

    <div v-else-if="images.length > 1" class="slideshow">
        <div class="slideshow__imagecontainer">
            <transition name="fade" mode="out-in">
                <img :src="currentImage" class="slideshow__image" :key="currentImage" @click.prevent="next"/>
            </transition>
        </div>
        <div class="slideshow__controls">
            <a href="#" class="slideshow__previous" @click.prevent="previous">prev</a>
            <span class="slideshow__indicator">{{ currentIndex + 1 }}/{{ images.length }}</span>
            <a href="#" class="slideshow__next" @click.prevent="next">next</a>
        </div>
    </div>
</template>


<script>
import autoValidate from './autoValidateMixin'

export default {
    mixins: [
        autoValidate
    ],

    data: function() {
        return {
            currentIndex: 0,
        }
    },

    computed: {
        images: function() {
            if (this.partial.data == null) {
                return []
            }

            if (Array.isArray(this.partial.data)) {
                return this.partial.data
            }

            return [this.partial.data]
        },

        currentImage: function() {
            return this.images[ this.currentIndex ]
        }
    },

    methods: {
        previous: function() {
            this.currentIndex = this.currentIndex === 0 ? this.images.length - 1 : this.currentIndex - 1
        },

        next: function() {
            this.currentIndex = this.currentIndex === this.images.length - 1 ? 0 : this.currentIndex + 1
        },

        flush: function() {
            return Promise.resolve()
        },
    },
}

</script>


<style lang="scss">

    @import 'global';

    .partial-image {
        display: block;
        margin: 0 auto;
    }

    .slideshow {
        height: 100%;
        width: 100%;

        position: relative;
    }

    .slideshow__imagecontainer {
        margin: 1em 0;
        min-height: 576px;

        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .slideshow__image {
        display: block;
        margin: 0 auto !important;
    }

    .slideshow__controls {
        height: 28px;
        line-height: 28px;
        width: 100%;
        text-align: center;
    }

    .slideshow__indicator {
        display: inline-block;
        min-width: 4em;
        vertical-align: top;
        font-size: 0.9em;
        padding: 0 0.5em;
    }

    .slideshow__previous {
        @include background-sprite-replace($arrow-backward-group);
        display: inline-block;
        vertical-align: middle;
    }

    .slideshow__next {
        @include background-sprite-replace($arrow-forward-group);
        display: inline-block;
        vertical-align: middle;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .3s
    }

    .fade-enter, .fade-leave-to, .fade-leave-active {
      opacity: 0
    }


</style>



// WEBPACK FOOTER //
// ImagePartial.vue?5cf81453